import React, { useState } from 'react';
import { Plus, Search, CheckCircle, Clock, AlertCircle } from 'lucide-react';

const Payments = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const payments = [
    { id: 1, parent: 'Sarah Johnson', student: 'Emma Johnson', amount: 120, description: 'Ballet Beginners - Jan 2024', status: 'paid', date: '2024-01-01' },
    { id: 2, parent: 'Sarah Johnson', student: 'Liam Johnson', amount: 150, description: 'Gymnastics Level 1 - Jan 2024', status: 'paid', date: '2024-01-01' },
    { id: 3, parent: 'Mike Williams', student: 'Sophia Williams', amount: 80, description: 'Art Club - Jan 2024', status: 'pending', date: '2024-01-05' },
    { id: 4, parent: 'Emily Brown', student: 'Noah Brown', amount: 120, description: 'Ballet Beginners - Jan 2024', status: 'overdue', date: '2024-01-01' },
  ];

  const filteredPayments = payments.filter(p =>
    p.parent.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.student.toLowerCase().includes(searchTerm.toLowerCase()) ||
    p.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getStatusBadge = (status) => {
    const styles = {
      paid: 'badge-success',
      pending: 'badge-warning',
      overdue: 'badge-danger',
    };
    const icons = {
      paid: <CheckCircle size={14} className="mr-1" />,
      pending: <Clock size={14} className="mr-1" />,
      overdue: <AlertCircle size={14} className="mr-1" />,
    };
    return (
      <span className={`badge ${styles[status]} flex items-center`}>
        {icons[status]}
        {status}
      </span>
    );
  };

  return (
    <div className="animate-fade-in">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Payments</h1>
          <p className="text-gray-500 mt-1">Manage payments and invoicing.</p>
        </div>
        <button className="mt-4 sm:mt-0 btn-primary flex items-center space-x-2">
          <Plus size={20} />
          <span>Create Invoice</span>
        </button>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-xl p-4 shadow-sm border border-purple-100">
          <p className="text-sm text-gray-500">Total Revenue</p>
          <p className="text-2xl font-bold text-purple-600">$12,450</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-purple-100">
          <p className="text-sm text-gray-500">Paid</p>
          <p className="text-2xl font-bold text-green-600">$10,200</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-purple-100">
          <p className="text-sm text-gray-500">Pending</p>
          <p className="text-2xl font-bold text-yellow-600">$1,500</p>
        </div>
        <div className="bg-white rounded-xl p-4 shadow-sm border border-purple-100">
          <p className="text-sm text-gray-500">Overdue</p>
          <p className="text-2xl font-bold text-red-600">$750</p>
        </div>
      </div>

      {/* Search */}
      <div className="mb-6">
        <div className="relative max-w-md">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" size={20} />
          <input
            type="text"
            placeholder="Search payments..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="form-input pl-12"
          />
        </div>
      </div>

      {/* Payments Table */}
      <div className="bg-white rounded-xl shadow-sm border border-purple-100 overflow-hidden">
        <div className="overflow-x-auto -mx-6 px-6">
          <table className="w-full min-w-[600px]">
          <thead className="bg-purple-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Parent</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Student</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Description</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Amount</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-purple-700 uppercase">Status</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-purple-700 uppercase">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-purple-50">
            {filteredPayments.map((payment) => (
              <tr key={payment.id} className="hover:bg-purple-50/50">
                <td className="px-6 py-4 font-medium text-gray-900">{payment.parent}</td>
                <td className="px-6 py-4 text-gray-500">{payment.student}</td>
                <td className="px-6 py-4 text-gray-500">{payment.description}</td>
                <td className="px-6 py-4 font-medium text-gray-900">${payment.amount}</td>
                <td className="px-6 py-4">{getStatusBadge(payment.status)}</td>
                <td className="px-6 py-4 text-right">
                  <button className="px-4 py-2 min-h-[44px] text-sm text-purple-600 hover:text-purple-700 hover:bg-purple-50 rounded-lg font-medium">
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  );
};

export default Payments;
